import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { PdfViewerService } from '@core/services/pdf/pdf-viewer.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NadaSpinnerComponent } from '@shared/components/nada-spinner/nada-spinner.component';

@Component({
  selector: 'app-pdf-viewer-page',
  standalone: true,
  imports: [CommonModule, NadaSpinnerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './pdf-viewer-page.component.html',
  styleUrl: './pdf-viewer-page.component.css',
})
export class PdfViewerPageComponent implements OnInit, OnDestroy {
  pdfSrc: SafeResourceUrl | null = null;
  exportSpinner = false;

  constructor(
    private pdfViewerService: PdfViewerService,
    private sanitizer: DomSanitizer,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  ngOnInit() {
    this.exportSpinner = true;
    const pdfBlob = this.pdfViewerService.getPdfData();
    if (pdfBlob) {
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
        URL.createObjectURL(pdfBlob),
      );
    } else if (isPlatformBrowser(this.platformId)) {
      history.go(-1); // Navigate back only in the browser environment
    }

    this.exportSpinner = false;
  }

  ngOnDestroy() {
    if (this.pdfSrc) {
      //URL.revokeObjectURL(this.pdfSrc); // Cleanup memory
    }
  }

  downloadPDF() {
    const pdfBlob = this.pdfViewerService.getPdfData(); // Get the PDF blob from the service

    if (pdfBlob instanceof Blob) {
      const link = document.createElement('a'); // Create an anchor element
      link.href = URL.createObjectURL(pdfBlob);
      link.download = 'document.pdf'; // Set the default file name
      link.style.display = 'none';
      document.body.appendChild(link);
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        }),
      ); // Simulate a click to trigger download
      URL.revokeObjectURL(link.href); // Free up memory
      link.remove(); // Clean up the DOM
    }
  }

  closeViewer() {
    this.pdfSrc = null;
    let pdfUrl;
    if (isPlatformBrowser(this.platformId)) {
      pdfUrl = localStorage.getItem('pdfUrl');
    }
    if (pdfUrl) {
      this.router.navigateByUrl(pdfUrl);
    }
  }
}
